import * as React from 'react';
import * as DateFns from 'date-fns';
import { Dialog, Button, Input } from 'arbina-ui';
import { Item, Pack } from 'types';
import { Items } from './components/Items';
import * as style from './style.sass';

interface Properties {
  pack: Pack;
  onClose: () => any;
  onSubmit: (pack: Pack) => Promise<any>;
}

interface State {
  pack: Pack;
  submitting: boolean;
  publishNow: boolean;
}

export class EditDialog extends React.Component<Properties> {
  state: State = {
    pack: {
      ...this.props.pack,
      publishAt: this.props.pack.publishAt || DateFns.startOfToday(),
    },
    submitting: false,
    publishNow: false,
  };

  onItemsChanged = (items: Item[]) => {
    this.setState({
      pack: {
        ...this.state.pack,
        items,
      },
    });
  }

  onPublishDateChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { pack } = this.state;
    this.setState({
      pack: {
        ...this.state.pack,
        publishAt: new Date(DateFns
          .startOfDay(new Date(event.target.value))
          .setHours(pack.publishAt ? pack.publishAt.getHours() : 15)),
      },
    });
  }

  onPublishHourChanged = (hour: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const { pack } = this.state;
    this.setState({
      pack: {
        ...this.state.pack,
        publishAt: DateFns.setHours(
          pack.publishAt || new Date(),
          event.target.checked ? hour : 0),
      },
    });
  }

  onPublishNowChanged = () => this.setState({ publishNow: !this.state.publishNow });

  onSubmit = async () => {
    const { publishNow, pack } = this.state;

    try {
      this.setState({ submitting: true });

      await this.props.onSubmit({
        ...pack,
        publishAt: publishNow ?
          new Date() :
          pack.publishAt && pack.publishAt.getHours() ?
            pack.publishAt :
            null,
      });
    } finally {
      this.setState({ submitting: false });
    }
  }

  render() {
    const { onClose } = this.props;
    const { pack, submitting, publishNow } = this.state;

    return (<Dialog
      title={`${pack.id ? 'Edit' : 'Add new'} pack`}
      onClose={onClose}
    >
      <div className={style.publishRow}>
        <Input
          disabled={publishNow}
          hint="Publish at:"
          type="date"
          value={pack.publishAt ? DateFns.format(pack.publishAt, 'YYYY-MM-DD') : ''}
          onChange={this.onPublishDateChanged}
        />
        <div className={style.timeBox}>
          <label>
            <Input
              disabled={publishNow}
              className={style.timeCheck}
              type="checkbox"
              checked={pack.publishAt ? new Date(pack.publishAt).getHours() === 15 : false}
              onChange={this.onPublishHourChanged.bind(this, 15)}
            /> 3 p.m.
          </label>
          {' / '}
          <label>
            <Input
              disabled={publishNow}
              className={style.timeCheck}
              type="checkbox"
              checked={pack.publishAt ? new Date(pack.publishAt).getHours() === 23 : false}
              onChange={this.onPublishHourChanged.bind(this, 23)}
            /> 11 p.m.
          </label>
        </div>
        <div className={style.orBox}>or</div>
        <div className={style.nowBox}>
          <label>
            <Input
              className={style.timeCheck}
              type="checkbox"
              checked={publishNow}
              onChange={this.onPublishNowChanged}
            /> publish now
          </label>
        </div>
      </div>
      <div className={style.items}>
        <Items
          items={pack.items}
          onItemsChanged={this.onItemsChanged}
        />
      </div>
      <Button
        primary
        disabled={
          !pack.items.length ||
          (!pack.publishAt ||
            (new Date(pack.publishAt).getHours() !== 15 &&
              new Date(pack.publishAt).getHours() !== 23 &&
              !publishNow)) ||
          submitting}
        text="Save"
        onClick={this.onSubmit}
      />
    </Dialog>);
  }
}
